import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { AngularFirestore } from '@angular/fire/firestore';
@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss'],
})
export class ProfileCardComponent implements OnInit {

  @Input() public uid: any;
  @Input() public user: any;
  sharedPostCount = 0;
  connectionsCount = 0;
  constructor(
    public authService: AuthService,
    public firestore: AngularFirestore,

  ) {

  }

  ngOnInit() {
    console.log(this.uid);
    if (this.uid && !this.user) {
      this.authService.getUser(this.uid).then((user) => {
        this.user = user;
        this.countPostShared();
        this.countConnections();
      });
    } else {
      if (this.user) {
        this.countPostShared();
        this.countConnections();
      }
    }

  }

  async countConnections() {
    if (this.user?.id) {
      const q = this.firestore.collection('connections', ref => ref.where('users', 'array-contains', this.user.id));
      const documentSnapshots = await q.get().toPromise();
      this.connectionsCount = documentSnapshots.size;
    }
  }

  async countPostShared() {
    if (this.user?.id) {
      const q = this.firestore.collection('articles', ref => ref.where('user', '==', this.user.id));
      const documentSnapshots = await q.get().toPromise();
      this.sharedPostCount = documentSnapshots.size;
    }
  }

  ionviewDidLeave() {

  }

}
